import { useHMSActions } from "@100mslive/react-sdk";

export const useHMSLeaveRoom = () => {
  const hmsActions = useHMSActions();

  return () => hmsActions.leave();
};
